import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PaymentMethod } from '@app/shared/interfaces/payment-method';
import { AppConfig } from '@config/app.config';
import { PaymentMethodsRepository } from '@core/repositories/payment-methods.repository';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiPaymentMethodsRepository implements PaymentMethodsRepository {
  public url = this.appConfig.URL + '/segments/';

  constructor(public appConfig: AppConfig, public http: HttpClient) {}

  getItems(): Observable<any> {
    return this.http.get(this.url);
  }

  add(paymentMethod: PaymentMethod): Observable<any> {
    const data = {
      data: {
        id: paymentMethod.id,
        type: 'Segment',
        attributes: {
          name: paymentMethod.name
        }
      }
    };
    return this.http.post(this.url, data);
  }

  edit(paymentMethod: PaymentMethod): Observable<any> {
    const data = {
      data: {
        id: paymentMethod.id,
        type: 'Segment',
        attributes: {
          name: paymentMethod.name
        }
      }
    };
    return this.http.put(this.url, data);
  }

  delete(item: any): Observable<any> {
    return this.http.delete(this.url + item);
  }
}
